import { CardStyleInterpolators } from '@react-navigation/stack';
import { lazy } from 'react';
import { Platform } from 'react-native';
import { adaptiveWrapperOptions } from '../../appComponents/ModalWrapper';
import { wrapLazyNavigatorScreen } from '../../functions/navigation/utils/wrapNavigatorScreen';

const PopClipFlowContent = lazy(() => import('./content'));

const PopClipFlow = wrapLazyNavigatorScreen(
  PopClipFlowContent,
  adaptiveWrapperOptions(isMobile =>
    isMobile
      ? {
          presentation: undefined,
          headerTransparent: true,
          cardStyleInterpolator:
            Platform.OS === 'ios'
              ? CardStyleInterpolators.forVerticalIOS
              : undefined,
          title: '',
        }
      : {},
  ),
);

export default PopClipFlow;
